/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// const $window = $(window);
	// let windowWidth = $window.width();
	// // メディアクエリ
	// let mql = window.matchMedia('screen and (max-width: 1024px)');
	//preload
	(0, _module.preload)(); // toggleHeader
	
	(0, _module.toggleHeader)(); //pageTop
	
	(0, _module.pageTop)(); //showMovie
	
	(0, _module.showMovie)(); //showAbout
	
	(0, _module.showAbout)(); //anchorLink
	
	(0, _module.anchorLink)();
	$(window).on('load', function () {
	  // setTimeout(function(){$('#st-Loader .st-Loader_Logo').addClass("load");},400);
	  // setTimeout(function(){$('#st-Loader').addClass("hidden");},1200);
	  // setTimeout(function(){$('#st-Loader').remove();},1600);
	  // setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},1600);
	  scrollIndexAnime();
	  toggleChara();
	}); // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); //ページトップ出現
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Story',
	    triggerHook: 1,
	    offset: '80'
	  }).setClassToggle('#st-Top', 'st-Top-Show').addTo(controller); //アプリ誘導
	
	  var scene2 = new ScrollMagic.Scene({
	    triggerElement: '.index-Story',
	    triggerHook: 1,
	    offset: '80'
	  }).setClassToggle('#following', 'show').addTo(controller); //アプリ誘導
	
	  var scene3 = new ScrollMagic.Scene({
	    triggerElement: '.st-Footer',
	    triggerHook: 1,
	    offset: '80'
	  }).setClassToggle('#following, #st-Top', 'hidden').addTo(controller); // //　スクロールで発火系
	  // const targets = document.querySelectorAll(".js-scrollAnimation");
	  // const targetsArray = Array.prototype.slice.call(targets); //Array
	  // targetsArray.forEach(target => {
	  //   //シーンを作成
	  //   const scene3 = new ScrollMagic.Scene({
	  //       triggerElement: target,
	  //       triggerHook: .8
	  //   })
	  //   .setClassToggle(target, "is-animated")
	  //   .addTo(controller);
	  // });
	}; // ------------------------------------------------------------------------
	// toggleChara
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var toggleChara = function toggleChara() {
	  // こころ
	  var charaSwiper0;
	  charaSwiper0 = new Swiper('.illust-slide-kokoro', {
	    initialSlide: 0,
	    // 0で特訓前 1で特訓後
	    effect: 'flip',
	    grabCursor: true,
	    speed: 600,
	    loop: true,
	    pagination: {
	      el: '.slide-pagination-kokoro',
	      clickable: true
	    },
	    allowTouchMove: true
	  }); // 薫
	
	  var charaSwiper1;
	  charaSwiper1 = new Swiper('.illust-slide-kaoru', {
	    initialSlide: 1,
	    // 0で特訓前 1で特訓後
	    effect: 'flip',
	    grabCursor: true,
	    speed: 600,
	    loop: true,
	    pagination: {
	      el: '.slide-pagination-kaoru',
	      clickable: true
	    },
	    allowTouchMove: true
	  }); // はぐみ
	
	  var charaSwiper2;
	  charaSwiper2 = new Swiper('.illust-slide-hagumi', {
	    initialSlide: 0,
	    // 0で特訓前 1で特訓後
	    effect: 'flip',
	    grabCursor: true,
	    speed: 600,
	    loop: true,
	    pagination: {
	      el: '.slide-pagination-hagumi',
	      clickable: true
	    },
	    allowTouchMove: true
	  }); // 花音
	
	  var charaSwiper3;
	  charaSwiper3 = new Swiper('.illust-slide-kanon', {
	    initialSlide: 0,
	    // 0で特訓前 1で特訓後
	    effect: 'flip',
	    grabCursor: true,
	    speed: 600,
	    loop: true,
	    pagination: {
	      el: '.slide-pagination-kanon',
	      clickable: true
	    },
	    allowTouchMove: true
	  }); // 美咲
	
	  var charaSwiper4;
	  charaSwiper4 = new Swiper('.illust-slide-misaki', {
	    initialSlide: 0,
	    // 0で特訓前 1で特訓後
	    effect: 'flip',
	    grabCursor: true,
	    speed: 600,
	    loop: true,
	    pagination: {
	      el: '.slide-pagination-misaki',
	      clickable: true
	    },
	    allowTouchMove: true
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.showAbout = exports.showMovie = exports.pageTop = exports.toggleHeader = exports.preload = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu'); // var windowW       = $(window).width();
	// var windowH       = $(window).innerHeight();
	// var _isSP         = false;
	// var _isipad  = false;
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderLogo.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    stHeaderLogo.classList.add('closed');
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  }); //object-fit
	
	  objectFitImages('img.object-fit-img');
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#movie-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('#movie-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// showAbout
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var showAbout = function showAbout() {
	  var $event = $('#about-Stage');
	  $('.js-about').on('click', function () {
	    $('#about-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      // fadeIn
	      $event.stop().fadeIn(400);
	      $('#about-Box').addClass('show');
	      return false;
	    });
	  }); //close
	
	  $('#about-Box,#about-Box_Close').on('click', function () {
	    $('#about-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#about-Stage').css({
	        'display': 'none'
	      });
	      $('#about-Box').removeClass('show');
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showAbout = showAbout;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 50;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var __layer = $('.st-Container').attr('data-layer');
	
	  var linkSpeed = 700;
	  var linkAdjust = 50; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  }); //トップページ時ののヘッダーリンク
	
	  $(".header-link").on("click", function () {
	    if (__layer == 'first') {
	      var linkHref = $(this).attr("href");
	      var linkHash = linkHref.replace("./", "");
	      var linkTarget = $(linkHash == "#" || linkHash == "" ? 'html' : linkHash);
	      var linkPosition = linkTarget.offset().top;
	
	      if (headerFlag) {
	        stHeader.classList.remove('opened');
	        stHeaderNav.classList.remove('opened');
	        headerButton.classList.remove('opened');
	        stHeaderBg.classList.remove('opened');
	        stHeader.classList.add('closed');
	        stHeaderNav.classList.add('closed');
	        headerButton.classList.add('closed');
	        stHeaderBg.classList.add('closed');
	        headerFlag = false;
	      }
	
	      $("html, body").animate({
	        scrollTop: linkPosition - linkAdjust
	      }, linkSpeed, "easeInOutQuint");
	      return false;
	    }
	  });
	};
	
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js